import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

export function sliderHome2() {
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".home-slider")) {
      const homeSlideArrowVisible = document.getElementById(
        "homeSlideArrowVisible"
      )
        ? document.getElementById("homeSlideArrowVisible").value
        : false;
      console.log("homeSlideArrowVisible: " + homeSlideArrowVisible);

      var sliderHome = new Splide(".home-slider", {
        perPage: 1,
        perMove: 1,
        autoplay: false,
        interval: 5500,
        pagination: false,
        arrows: homeSlideArrowVisible,
        drag: true,
      }).mount();
    }
    /*
      sliderHome.on('mounted', () => {

        if (sliderHome.length <= sliderHome.options.perPage) {
          sliderHome.options = {
            arrows: false,
            pagination: false,
            drag: false
          };
          sliderHome.destroy();
          sliderHome.mount();
        }
      })

      sliderHome.mount();*/
  });
}
